<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div class="mt-15 ml-15 mr-15">
      <v-card>
        <v-card-title class="primary--text">
          {{ $t("users.edituser") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <ValidationObserver
            ref="obs"
            v-slot="{ invalid, validated, handleSubmit }"
          >
            <v-form ref="form">
              <v-row>
                <v-col cols="6">
                  <BaseValInput
                    rules="required|min:8"
                    v-model="password"
                    v-bind:label="$t('users.password')"
                  />
                </v-col>
              </v-row>
              <div class="text-end mr-15">
                <v-btn color="accent" @click="closeItem()" class="mr-8">{{
                  $t("crud.close")
                }}</v-btn>

                <v-btn
                  color="primary"
                  @click="handleSubmit(saveItem)"
                  :disabled="invalid"
                  >{{ $t("crud.change") }}</v-btn
                >
              </div>
            </v-form>
          </ValidationObserver>
          <FlashMessage :error="error" v-if="error" key="error" />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import BaseValInput from "@/components/input/BaseValInput";
import { ValidationObserver } from "vee-validate";
import FlashMessage from "@/components/input/FlashMessage";
import { getError } from "@/utils/helpers";
import UserService from "@/services/UserService";
export default {
  name: "Users",
  components: {
    FlashMessage,
    BaseValInput,
    ToolbarAuth,
    Navigation,
    ValidationObserver,
  },
  data() {
    return {
      password: null,
      loading: null,
      error: null,
    };
  },
  methods: {
    getData() {
      let id = this.$route.params.id;
      this.loading = true;
      UserService.getUser(id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },

    saveItem() {
      const payload = {
        password: this.password,
      };
      this.error = null;
      let UserId = this.$route.params.id;
      UserService.updatePW(UserId, payload)
        .then(() => {
          this.$router.replace({ name: "usersIndex" });
        })
        .catch((error) => (this.error = getError(error)));
    },

    closeItem() {
      this.$router.replace({ name: "usersIndex" });
    },
  },

  mounted() {},
};
</script>

<style scoped></style>
